import React from 'react';
import { Navigate } from 'react-router-dom';

export default function RequireAdmin({ user, children }) {
  if (!user) {
    return <Navigate to="/auth/signin" replace />;
  }

  if (user?.role !== 'super_admin') {
    return <Navigate to="/" replace />;
  }

  return children;
}
